import React from 'react';
export function ProofSection() {
  return <section className="w-full bg-[#f8fafc] py-16 px-4" data-id="element-262" data-mp="25tdyr96b1voj">
      <div className="max-w-4xl mx-auto" data-id="element-263" data-mp="2v1z2sk3uei09">
        <div className="bg-white rounded-lg p-8 md:p-12 shadow-lg border-t-4 border-[#fbbf24]" data-id="element-264" data-mp="2v30pjlu80sxt">
          <div className="text-center mb-6" data-id="element-265" data-mp="300iqaoy341uq">
            <div className="text-6xl md:text-7xl font-bold text-[#fbbf24] mb-2" data-id="element-266" data-mp="351g6ivzjaltl">
              $42.000 CLP
            </div>
            <div className="text-xl text-gray-600 mb-8" data-id="element-267" data-mp="39yyeaj1tev00">
              ahorro promedio en la primera quincena
            </div>
          </div>

          <div className="relative" data-id="element-268" data-mp="3dz8lu0599tgz">
            <div className="absolute top-0 left-0 text-6xl text-[#fbbf24] opacity-20 leading-none" data-id="element-269" data-mp="3is1q6mwtazsj">
              "
            </div>
            <p className="text-lg md:text-xl text-[#1a2332] leading-relaxed pl-8 pr-4 italic" data-id="element-270" data-mp="3nqwlupfvoiu2">
              Un usuario promedio del Protocolo Solo-Survival en Santiago
              reporta un ahorro de $42.000 CLP en su primera quincena de
              aplicación, simplemente eliminando el gasto hormiga y optimizando
              el "Precio por Unidad" en marcas blancas.
            </p>
            <div className="absolute bottom-0 right-0 text-6xl text-[#fbbf24] opacity-20 leading-none" data-id="element-271" data-mp="10mu2ogogkyhy">
              "
            </div>
          </div>
        </div>
      </div>
    </section>;
}